<template>
	
	<div>
		
		<layout>

			<template v-slot:title> 
				PERFIL
			</template>

			<template v-slot:subtitle> 
				PERFIL
			</template>

			<template v-slot:content>

				<v-container id="perfil">
					<v-row class="mt-4 mb-4">

						<v-col offset-md="2" md="4" offset="0" cols="12">
							<MisDatos />
						</v-col>

						<v-col md="4" cols="12">
							<ChangeEmail />
						</v-col>

					</v-row>
				</v-container>

			</template>

		</layout>
		

	</div>

</template>


<script>
	
	import Layout from './../../layout/Layout'

	import MisDatos from './components/MisDatos'
	import ChangeEmail from './components/ChangeEmail'

	export default 
	{
		
		data() {
			return {
				
			}
		},

		components: {
			Layout,
			MisDatos,
			ChangeEmail
		},

		created() {

		},

		methods: {

		}

	}

</script>